import { useState } from "react";
import { ComponentConfig } from "@measured/puck";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import ScoreSelectField from "../../fields/ScoreSelectField";
import VariationSelectField from "../../fields/VariationSelectField";

import { ScoreChartBlock, ScoreChartBlockProps } from "./ScoreChartBlock";

export type ScoreChartBlockConfigProps = Omit<ScoreChartBlockProps, "scoreId" | "variationId"> & {
    score?: ScoreSelection;
};

type ScoreSelection = {
    scoreId: number | null;
    variationId: string | null;
};

type ScoreVariationFieldProps = {
    value: ScoreSelection | undefined;
    onChange: (value: ScoreSelection) => void;
};
const ScoreVariationField = (props: ScoreVariationFieldProps) => {
    const { value, onChange } = props;
    const theme = useTheme();

    const [selection, setSelection] = useState<ScoreSelection>(
        value || {
            scoreId: null,
            variationId: null,
        },
    );

    const updateSelection = (newSelection: Partial<ScoreSelection>) => {
        const updatedSelection = {
            ...selection,
            ...newSelection,
        };
        setSelection(updatedSelection);
        onChange(updatedSelection);
    };

    const handleScoreChange = (value: number | undefined) => {
        updateSelection({
            scoreId: value,
            variationId: null,
        });
    };

    const handleVariationChange = (value: string | null) => {
        updateSelection({
            variationId: value,
        });
    };

    return (
        <>
            <Box>
                <ScoreSelectField
                    value={selection.scoreId}
                    onChange={handleScoreChange}
                    field={{ type: "custom", render: () => <></> }}
                    name="score.scoreId"
                    id="score-field"
                />
            </Box>

            <Box sx={{ marginTop: theme.spacing(2) }} />

            {selection.scoreId ?
                <Box>
                    <VariationSelectField
                        scoreId={selection.scoreId}
                        value={selection.variationId}
                        onChange={handleVariationChange}
                        field={{ type: "custom", render: () => <></> }}
                        name="score.variationId"
                        id="variation-field"
                    />
                </Box>
            :   <></>}
        </>
    );
};

export default {
    name: "Score Chart",
    label: "Score Chart",
    fields: {
        score: {
            type: "custom",
            label: "Score & Variation",
            render: (props) => <ScoreVariationField value={props.value} onChange={props.onChange} />,
        },
    },
    defaultProps: {
        score: {
            scoreId: null,
            variationId: null,
        },
    },
    render: ({ score, ...rest }) => {
        return <ScoreChartBlock scoreId={score?.scoreId} variationId={score?.variationId} {...rest} />;
    },
} as ComponentConfig<ScoreChartBlockConfigProps>;
